<mat-card-header>
	<mat-card-title>
		MSD Number Merged Tree


		<mat-icon *ngIf="isLoading">
			<mat-spinner diameter="20"> </mat-spinner>
		</mat-icon>

		<button *ngIf="data" class="close-button" mat-mini-fab (click)="closeDialog(false)">
			<mat-icon>close</mat-icon>
		</button>
	</mat-card-title>
</mat-card-header>

<mat-card-content *ngIf="!isLoading">
	<div
		[ngClass]="{ 'black': studentMergedTree.STUDENTS_ID !== studentId, 'primary bold': studentMergedTree.STUDENTS_ID == studentId }">
		<h2 class="no-margin" *ngIf="studentMergedTree.MSD_NUMBER">{{studentMergedTree.MSD_NUMBER}}</h2>
		<h2 class="no-margin" *ngIf="!studentMergedTree.MSD_NUMBER">00000000000</h2>
	</div>
	<div *ngFor="let branch of studentMergedTree.STUDENT_MERGED_TREE_BRANCHES; let i = index;">
		<view-children-merge-tree-branches [tree]="branch" [studentMsdNumber]="studentMsdNumber"
			[studentId]="studentId"></view-children-merge-tree-branches>
	</div>
</mat-card-content>

<hr />

<view-resolved-children-merge-history *ngIf="!isLoading" [studentId]="studentId"></view-resolved-children-merge-history>